<template>
  <van-cell-group class="info-second">
    <van-cell class="custom">
      <template #title>
        <span class="custom-title">{{title}}</span>
        <van-button type="info" size="small" round @click="change" v-if="!!id && disabled2 == true">编辑</van-button>
        <van-button type="info" size="small" round @click="submit" v-if="!!id && disabled2 == false">保存</van-button>
      </template>
    </van-cell>
    <van-form @submit="submit" ref="vanForm">
      <div  v-for="(item, index) in models" :key="item.key">
        <field-list-item :datas="item" :value="valueList[index]" :disabled="disabled" ref="fieldListItem" :id="id" />
      </div>
    </van-form>
  </van-cell-group>
</template>

<script>
import fieldListItem from './field-list-item.vue'
export default {
  components: { fieldListItem },
  props: ['title', 'data', 'value', 'disabled', 'id',],
  data () {
    return {
      models: [],
      valueList: [],
      disabled2: this.disabled
    }
  },
  watch: {
    data: {
      deep: true,
      handler (val) {
        this.updateData(val.list)
      }
    },
    value: {
      deep: true,
      handler (val) {
        this.setValue(val)
      }
    }
  },
  created () {
    this.updateData(this.data.list)
  },
  methods: {
    change() {
      this.disabled2 = false
      this.$nextTick(() => {
        this.$emit('fatherChange', this.disabled2)
      })
    },
    updateData (list) {
      let newList = []
      list.forEach(item => {
        if (item.columns) {
          item.columns.forEach(val => {
            newList.push(...val.list)
          })
        } else {
          newList.push(item)
        }
      })
      this.models = newList
    },
    setValue (value) {
      let keys =  Object.keys(value)
      this.models.forEach((item, index) => {
        if (value.length < 1 || value[keys.find(val => val == item.model)] == '') {
          this.valueList.push(item.options.defaultValue)
        } else {
          this.valueList.push(value[keys.find(val => val == item.model)])
        }
      })
    },
    submit (val) {
      this.disabled2 = true
      this.$nextTick(() => {
        this.$emit('submit')
      })
    },
    getData () {
      return new Promise((resolve, reject) => {
        this.$refs.vanForm.validate().then(res => {
          let obj = {}
          this.$refs.fieldListItem.forEach(item => {
            let itemValue = item.getValue()
            obj[itemValue.key] = itemValue.value
          })
          resolve(obj)
        }).catch(err => {
          reject(new Error(this.$t('fm.message.validError')).message)
        })
      })
    }
  }
}
</script>

<style>

</style>
